/**
 * 한글 단위 포맷팅
 * @param num 숫자
 * @returns 한글 단위 포맷팅 문자열
 * @example
 * formatKoreanUnitsFull(10000) => "1만"
 * formatKoreanUnitsFull(1000) => "1천"
 * formatKoreanUnitsFull(100) => "1백"
 * formatKoreanUnitsFull(10) => "1십"
 * formatKoreanUnitsFull(1) => "1"
 * formatKoreanUnitsFull(0) => "0"
 */
export function formatKoreanUnitsFull(num: number): string {
  if (num === 0) return "0";

  const units = [
    { value: 10000, label: "만" },
    { value: 1000, label: "천" },
    { value: 100, label: "백" },
    { value: 10, label: "십" },
  ];

  const parts: string[] = [];

  for (const { value, label } of units) {
    const count = Math.floor(num / value);
    if (count > 0) {
      parts.push(`${count}${label}`);
      num %= value;
    }
  }

  if (num > 0) {
    parts.push(`${num}`);
  }

  return parts.join(" ");
}

export const splitCategoryTitle = (title: string) => {
  const match = title?.match(/^(\[.*?\])\s*(.*)/);

  return {
    category: match?.[1] ?? "",
    title: match?.[2] ?? title,
  };
};
/**
 * 디바이스 타입 감지
 * @returns "mobile" 또는 "pc"
 */
declare global {
 interface Navigator {
    userAgentData?: {
      mobile?: boolean;
      brands?: { brand: string; version: string }[];
      getHighEntropyValues?: (hints: string[]) => Promise<Record<string, any>>;
    };
  }
}

export function detectDeviceByUa() {
  // 1. UA-CH 지원 브라우저 (Chrome 89+ 등)
  if (navigator.userAgentData) {
    return navigator.userAgentData.mobile ? "mobile" : "pc";
  }

  // 2. UA 기반 fallback
  const isMobileUA = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  return isMobileUA ? "mobile" : "pc";
}

export function diffDays(startDate: string, endDate: string) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const diffTime = Math.abs(end.getTime() - start.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}